// 1. สร้าง Map จับคู่ Domain กับ API
const apiTelehealthMap: { [key: string]: string } = {
    'meet.cliniclive.com': 'https://api.cliniclive.com',
    'meet.dentapop.com': 'https://api.dentapop.com',
    'meet.vettale.com': 'https://api.vettale.com'
  };

const apiMessageSmsMap: { [key: string]: string } = {
    'meetclinic.izpalapp.com': 'https://api.cliniclive.com',
    'meetdentapop.izpalapp.com': 'https://api.dentapop.com',
    'meetvettale.izpalapp.com': 'https://api.vettale.com'
  };
  
const getProductionTelehealthApi = (): string => {
  const currentHost = window.location.hostname;
  
  if (currentHost in apiTelehealthMap) {
    return apiTelehealthMap[currentHost];
  }
  console.error(`🚨 Production Error: Unknown Domain Host [${currentHost}]`);
  return '';
};

const getProductionSmsApi = (): string => {
  const currentHost = window.location.hostname;

  if (currentHost in apiMessageSmsMap) return apiMessageSmsMap[currentHost];
  return '';
};

export const environment = {
  production: true,
  staging: false,

  get apiUrlTelehealth() {
    return getProductionTelehealthApi();
  },
  prefixTelehealth: 'telehealth',

  get apiUrlMessageSms() {
      return getProductionSmsApi();
  },
  dailyDomain: 'izpal.daily.co'
};